// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "baggage-nOVEW";
var _3 = "baggageList-31mpb";
var _4 = "caryOnGroup-2TBA1";
var _5 = "baggageGroup-156ZC";
var _6 = "specialGroup-3niMd";
var _7 = "baggage_aggregation-g6Ixd";
export { _1 as "__esModule", _2 as "baggage", _3 as "baggageList", _4 as "caryOnGroup", _5 as "baggageGroup", _6 as "specialGroup", _7 as "baggage_aggregation" }
export default { "__esModule": _1, "baggage": _2, "baggageList": _3, "caryOnGroup": _4, "baggageGroup": _5, "specialGroup": _6, "baggage_aggregation": _7 }
